import request from '@/utils/request';

export function getPredata(params) {
  return request({
    url: '/api/external/foshan/predata',
    method: 'get',
    params,
  });
}

export function postDigitalEnvelope(data) {
  return request({
    url: '/api/external/foshan/digitalEnvelope',
    method: 'post',
    data,
  });
}

export function getBztQrcode(params) {
  return request({
    url: '/api/external/foshan/bzt/qrcode',
    method: 'get',
    params,
  });
}

export function getBztQueryResult(params) {
  return request({
    url: '/api/external/foshan/bzt/queryResult',
    method: 'get',
    params,
  });
}

export default {
  getPredata,
  postDigitalEnvelope,
  getBztQrcode,
  getBztQueryResult,
};
